import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeVisible = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m11 6a10 9.999975 0 0 0 -8.6855469 5.070312c.185109.291431.4456271.526926.7519531.689454a9 8.999978 0 0 1 7.9335938-4.759766 4 4 0 0 0 -4 4 4 4 0 0 0 4 4 4 4 0 0 0 4-4 4 4 0 0 0 -3.65625-3.9824219 9 8.999978 0 0 1 7.587891 4.7441409c.309422-.163642.571983-.402421.757812-.697266a10 9.999975 0 0 0 -8.689453-5.064453zm0 2a3 3 0 0 1 3 3 3 3 0 0 1 -3 3 3 3 0 0 1 -3-3 3 3 0 0 1 3-3zm0 1c-1.108 0-2 .892-2 2s.892 2 2 2 2-.892 2-2c0-.20481-.039017-.398205-.095703-.583984-.157882.343717-.49998.583984-.904297.583984-.554 0-1-.446-1-1 0-.404317.240267-.7464119.583984-.9042969-.185779-.05668-.379174-.0957031-.583984-.0957031z",
		fill: "currentColor"
	})
});
export default SvgEyeVisible;
